import { deriveLinearConversionFactors } from "../../Units/UnitConversion.js";
import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { SensorElementConfig } from "./types.js";

export const temperatureElementConfig: SensorElementConfig<Record<string, never>, typeof SensorConversions.unity> = {
    legalConvertedRange: [-50, 100],
    conversionKey: "unity",
    parameterConfigs: {},
    buildConversionParams: () => ({}),
    decodedUnits: "celsius",
    convertedUnits: "celsius",
    unitCategory: "airTemperature",
    testCases: [
        { parameters: {}, decodedValue: 25, convertedValue: 25 },
        { parameters: {}, decodedValue: -10, convertedValue: -10 },
    ],
} as const;

const { slope: fahrenheitSlope, offset: fahrenheitOffset } = deriveLinearConversionFactors("fahrenheit", "celsius");

/**
 * Air temperature decoded from Fahrenheit — e.g. Davis WeatherLink archive records, which report
 * `temp_last` in °F. Distinct from `temperatureElementConfig` above, which assumes the decoded
 * value already arrives in Celsius; named for the decoded encoding (mirrors `digitalPrecipitation`
 * et al. in `simpleDigitalSensorElements.ts`) rather than any particular source, so it can be
 * reused by any future Fahrenheit-reporting sensor.
 */
export const imperialTemperatureElementConfig: SensorElementConfig<
    Record<string, never>,
    typeof SensorConversions.linearWithMinAndMax
> = {
    legalConvertedRange: [-50, 100],
    conversionKey: "linearWithMinAndMax",
    parameterConfigs: {},
    buildConversionParams: () => ({
        slope: fahrenheitSlope,
        offset: fahrenheitOffset,
        outputMin: -50,
        outputMax: 100,
    }),
    decodedUnits: "fahrenheit",
    convertedUnits: "celsius",
    unitCategory: "airTemperature",
    testCases: [
        { parameters: {}, decodedValue: 32, convertedValue: 0 },
        { parameters: {}, decodedValue: 212, convertedValue: 100 },
        { parameters: {}, decodedValue: -10, convertedValue: -23.33333 },
    ],
} as const;
